import React, { Component } from "react";
import "./Terms.css";
import Header from "../LandingPage/Header/Header";

export default class Terms extends Component {
  render() {
    return (
      <div className="terms-container">
        <Header />
        <h1>Terms And Conditions:</h1>
        <p>
          Hello. Welcome to Cup O’ Sugar, Inc. (“we” “us” “our” or “Cup O’
          Sugar”)!
        </p>
        <p>
          The Cup O’ Sugar website (the “Site”), its applications (the “Apps”),
          and content available on the Site and Apps (the “Content”) are
          copyrighted work belonging to Cup O’ Sugar. Cup O’ Sugar services help
          connect users to food items available or needed in an effort to reduce
          food waste in local communities. Such services may be accessed through
          the Site, Apps, Content, APIs, and data feeds (collectively the
          “Services”).
        </p>
        <p>
          THIS TERMS OF SERVICE AGREEMENT (“AGREEMENT”) SETS FORTH THE LEGALLY
          BINDING TERMS FOR YOUR USE OF THE SERVICES. THIS AGREEMENT IS ACCEPTED
          BY YOUR ACCESSING AND/OR USE OF THE SERVICES. YOU MAY NOT ACCESS
          AND/OR USE THE SERVICES OR ACCEPT THE AGREEMENT IF YOU ARE NOT AT
          LEAST 18 YEARS OLD. BY ACCESSING AND/OR USING THE SERVICES, YOU
          REPRESENT AND WARRANT THAT YOU HAVE THE RIGHT, AUTHORITY, AND CAPACITY
          TO ENTER INTO THE AGREEMENT AND TO ABIDE BY ALL OF THE TERMS AND
          CONDITIONS SET FORTH HEREIN. IF YOU DO NOT AGREE WITH ALL PROVISIONS
          OF THIS AGREEMENT, PLEASE DO NOT ACCESS AND/OR USE THE SERVICES.
        </p>
        <p>
          PLEASE REVIEW CUP O’ SUGAR’S PRIVACY POLICY (
          <a href="/privacy">http://www.cuposugarapp.com/privacy</a>). THE TERMS
          OF THE PRIVACY POLICY ARE INCORPORATED INTO, AND CONSIDERED A PART OF,
          THIS AGREEMENT.
        </p>
        <p>CERTAIN DISCLAIMERS.</p>
        <p>
          ALL INFORMATION CONTAINED ON THE SERVICES (INCLUDING THE SITE, APPS,
          AND CONTENT), INCLUDING NUTRIENT INFORMATION, INGREDIENTS, FOOD
          ALLERGENS, AND INFORMATION RELATING TO MEDICAL AND HEALTH CONDITIONS
          IS FOR INFORMATIONAL PURPOSES ONLY AND NOT PROVIDED AS MEDICAL ADVICE.
          CUP O’ SUGAR DOES NOT ASSUME ANY LIABILITY FOR INACCURACIES OR
          MISSTATEMENTS ABOUT PRODUCTS, WHETHER BASED ON MANUFACTURER
          INFORMATION, THIRD PARTY INFORMATION, CUP O’ SUGAR USERS’ INFORMATION
          OR ON RATINGS AND ASSESSMENTS GENERATED BY CUP O’ SUGAR. YOU SHOULD
          CAREFULLY READ ALL INFORMATION PROVIDED BY THE MANUFACTURERS OF THE
          PRODUCTS, WHETHER ONLINE OR ON THE ACTUAL PRODUCT PACKAGING AND
          LABELS, INCLUDING NUTRIENT CONTENT, INGREDIENTS, FOOD ALLERGEN AND
          CONTACT INFORMATION, AND HEALTH CLAIMS, BEFORE USING OR CONSUMING A
          PRODUCT. FOR ADDITIONAL INFORMATION ABOUT A PRODUCT, PLEASE CONTACT
          THE MANUFACTURER DIRECTLY.
        </p>
        <p>
          INFORMATION ON THE SERVICES IS NOT INTENDED AS A SUBSTITUTE FOR THE
          ADVICE PROVIDED BY A QUALIFIED AND LICENSED HEALTHCARE PROFESSIONAL.
          YOU SHOULD NOT USE INFORMATION ON THE SERVICES FOR THE DIAGNOSIS OR
          TREATMENT OF A HEALTH PROBLEM OR DISEASES. YOU SHOULD ALWAYS CONSULT
          YOUR HEALTHCARE PROVIDER BEFORE MAKING ANY DIETARY OR NUTRITIONAL
          CHANGES.
          <br />
          IN ADDITION TO ALL OTHER LIMITATIONS AND DISCLAIMERS IN THIS
          AGREEMENT, CUP O’ SUGAR DISCLAIMS ANY LIABILITY OR LOSS IN CONNECTION
          WITH THE CONTENT PROVIDED ON THE SERVICES.
        </p>
        <p>USER ACCOUNTS</p>
        <p>
          Account Creation. In order to use certain features of the Services,
          you must register for an account with Cup O’ Sugar (“Cup O’ Sugar
          Account”) and provide certain information about yourself as prompted
          by the registration form. You represent and warrant that: (a) all
          required registration information you submit is truthful and accurate;
          (b) you will maintain the accuracy of such information; and (c) your
          use of the Services does not violate any applicable law or regulation
          or the terms of this Agreement.
        </p>
        <p>
          Account Responsibilities. You are responsible for maintaining the
          confidentiality of your Cup O’ Sugar Account login information and are
          fully responsible for all activities that occur under your Cup O’
          Sugar Account. You agree to immediately notify Cup O’ Sugar of any
          unauthorized use, or suspected unauthorized use of your Cup O’ Sugar
          Account or any other breach of security. Cup O’ Sugar cannot and will
          not be liable for any loss or damage arising from your failure to
          comply with the above requirements. We will protect your Cup O’ Sugar
          Account information in accordance with the Privacy Policy.
        </p>
        <p>
          Communication from Cup O’ Sugar and other Users. By using the Service,
          you agree to receive certain communications, for example, you may
          receive an update on products you scanned, or you may receive a
          periodic e-mail newsletter from Cup O’ Sugar. You can opt-out of
          non-essential communications by mailing contact@cuposugarapp.com or
          unsubscribing from the email notification.
        </p>
        <p>SERVICE</p>
        <p>
          Ownership. You acknowledge that all the intellectual property rights,
          including copyrights, patents, trademarks, and trade secrets, in the
          Services (including the Site, Apps, and Content, but excluding any
          User Content as defined herein) are owned by Cup O’ Sugar or Cup O’
          Sugar’s suppliers. The provision of the Services does not transfer to
          you or any third party any rights, title or interest in or to such
          intellectual property rights. Cup O’ Sugar and its suppliers reserve
          all rights not granted in this Agreement.
        </p>
        <p>
          License. Subject to the terms of this Agreement, Cup O’ Sugar grants
          you a non-transferable, non-exclusive, license (without the right to
          sub license) to (a) use the Services solely for your personal,
          non-commercial purposes, and (b) install and use the Apps, solely on
          your own handheld mobile device (e.g., iPhone, Android, etc. as
          applicable) and solely for your personal, non-commercial purposes.
          <br />
          Certain Restrictions. The rights granted to you in this Agreement are
          subject to the following restrictions: (a) you shall not license,
          sell, rent, lease, transfer, assign, distribute, host, or otherwise
          commercially exploit the Services; (b) you shall not modify, make
          derivative works of, disassemble, reverse compile or reverse engineer
          any part of the Services; (c) you shall not access the Services in
          order to build a similar or competitive service; (d) except as
          expressly stated herein, no part of the Services may be copied,
          reproduced, distributed, republished, downloaded, displayed, posted or
          transmitted in any form or by any means; (e) You may not copy or
          modify the code used to provide the Services; and (f) You may not use
          the Site, Apps, Content, or Services on or in connection with any
          other website, for any purpose. Any future release, update, or other
          addition to functionality of the Services shall be subject to the
          terms of this Agreement. All copyright and other proprietary notices
          on the Site must be retained on any copies.
        </p>
        <p>
          Use of Services at Your Own Risk. Your access to and use of the Site,
          Content, Apps, and Services is at your own risk. Cup O’ Sugar will
          have no responsibility for any harm to your computing system, loss of
          data, or other harm to you or any third party, including, without
          limitation, any bodily harm, that results from your access to or use
          of the Site, Apps, Content, or Services, or reliance on any
          information or advice with respect to any food products.
        </p>
        <p>
          Customer Support. Cup O’ Sugar has no obligation to provide you with
          customer support of any kind. However, Cup O’ Sugar may provide you
          with customer support from time to time, at Cup O’ Sugar’s sole
          discretion.
        </p>
        <p>
          Modification Of Services. Cup O’ Sugar reserves the right, at any
          time, to modify, suspend, or discontinue the Services (including the
          Site, Apps, and APIs) or any part thereof with or without notice. Cup
          O’ Sugar reserves the right to integrate into a different web service,
          migrate to a different URL, modify or discontinue, restrict or block
          access to, the Services without notice to you. Cup O’ Sugar may modify
          or remove any Content from the Services at any time without notice to
          you. Cup O’ Sugar is not liable for any such modification, suspension,
          discontinuance or removal. You agree that Cup O’ Sugar will not be
          liable to you or to any third party for any modification, suspension,
          or discontinuance of the Services or any part thereof.
        </p>
        <p>USER CONTENT</p>
        <p>
          User Content. “User Content” of a user means any photographs,
          pictures, content, text, artwork, files, programs, sound, graphics,
          video, data, product ratings, product comments, or forum post and
          other similar materials that a user submits, emails or otherwise uses
          with the Services. “Your User Content” means User Content that you
          provide to Cup O’ Sugar. “Media” means any means of conveying
          information, whether now known or hereafter devised. You are solely
          responsible for your User Content.
        </p>
        <p>
          You assume all risks associated with use of User Content, including
          any reliance on its accuracy, completeness or usefulness by others, or
          any disclosure of Your User Content that makes you or any third party
          personally identifiable.
          <br />
          License. By using Your User Content with the Services, you
          automatically grant, and you represent and warrant that you have the
          right to grant, to Cup O’ Sugar an irrevocable, nonexclusive,
          royalty-free and fully paid, worldwide license to reproduce,
          distribute, publicly display and perform, prepare derivative works of,
          incorporate into other works, and otherwise use Your User Content, and
          to grant sublicenses of the foregoing, solely for the purposes of
          including Your User Content in the Services. You agree to irrevocably
          waive (and cause to be waived) any claims and assertions of moral
          rights or attribution with respect to Your User Content.
        </p>
        <p>
          Feedback. Cup O’ Sugar will treat any feedback or suggestions you
          provide to Cup O’ Sugar as non-confidential and non-proprietary. Thus,
          in the absence of a written agreement with Cup O’ Sugar to the
          contrary, you agree that you will not submit to Cup O’ Sugar any
          information or ideas that you consider to be confidential or
          proprietary.
        </p>
        <p>
          User Content License Grants. You hereby grant to Cup O’ Sugar a
          worldwide, perpetual, irrevocable, nonexclusive, royalty-free,
          fully-paid up, transferable right and license, with the right to
          sublicense through multiple levels of sublicensees, under all of your
          intellectual property and other rights in Your User Content, to (a)
          reproduce, distribute, transmit, publicly perform and publicly display
          Your User Content, in whole or in part, in any manner and Media, (b)
          modify, adapt, translate and create derivative works from Your User
          Content, in whole or in part, in any manner and Media, (c) sublicense
          the foregoing rights, in whole or in part, to any third party, with or
          without a fee and (d) exercise any and all other present or future
          rights in Your User Content.
        </p>
        <p>
          Name, Trademarks and Likenesses License Grants. You hereby grant to
          Cup O’ Sugar a worldwide, perpetual, irrevocable, nonexclusive,
          royalty-free, fully-paid up, transferable right and license, with the
          right to sublicense through multiple levels of sublicensees, under all
          of your intellectual property and other rights in Your User Content,
          to use all trademarks, trade names and the names and likenesses of any
          individuals that appear in Your User Content. You grant Cup O’ Sugar
          the right to use the name that you submit in connection with Your User
          Content.
          <br />
          Moral Rights. You hereby waive and agree never to assert any claim of
          Moral Rights in Your User Content against Cup O’ Sugar or any of Cup
          O’ Sugar’s licensees. “Moral Rights” means any right to (a) divulge
          Your User Content to the public; (b) retract Your User Content from
          the public; (c) claim authorship of Your User Content; (d) object to
          any distortion, mutilation or other modification of Your User Content;
          or (e) any and all similar rights, existing under judicial or
          statutory law of any country or jurisdiction in the world, or under
          any treaty regardless of whether or not such right is called or
          generally referred to as a moral right.
          <br />
          Restrictions. You agree that you will not submit User Content that is
          unlawful, pornographic, libelous, defamatory, tortuous, obscene, or
          racially, ethnically or otherwise objectionable or that otherwise
          violates general Cup O’ Sugar community standards. We expressly
          reserve the right to remove or not make available any User Content
          that we deem to be in violation of this Agreement, applicable laws or
          our community standards in our sole discretion. You agree that you
          will not upload, post, e-mail or otherwise transmit User Content to us
          that contain software viruses or any other computer code, files, or
          programs designed to interrupt, destroy or limit the functionality of
          any computer software or hardware or telecommunications equipment.
        </p>
        <p>
          No Obligation. Although we have the right to include Your User Content
          in the Service or in any Media, we do not have the obligation to do
          so. We may, in our sole discretion and for any reason, refuse Your
          User Content or remove it from our Service at any time. We reserve the
          right to remove, screen, edit, or reinstate User Content from time to
          time at our sole discretion and without notice to you. We have no
          obligation to retain or provide you with copies of Your User Content,
          nor do we guarantee any confidentiality with respect to Your User
          Content. Advertising. Cup O’ Sugar and its licensees may publicly
          display advertisements and other information adjacent to or included
          with Your User Content. You are not entitled to any compensation for
          such advertisements. The manner, mode and extent of such advertising
          are subject to change without specific notice to you.
          <br />
          Representations and Warranties. You hereby affirm, represent, and
          warrant that (a) you own, or have the necessary licenses, rights,
          and/or consents to use Your User Content with the Services as
          described herein; (b) Your User Content does not infringe any
          copyright or any other intellectual property right of any third party;
          (c) Your User Content, and Cup O’ Sugar’s exercise of its rights here
          under, do not and will not violate, misappropriate or infringe any
          intellectual property right, including but not limited to trademark
          rights, copyrights, moral rights and publicity rights of any third
          party; (d) you possess all rights necessary for the reproduction,
          distribution, transmission, public performance, public display, and
          other exploitation of Your User Content by Cup O’ Sugar as permitted
          here under; (e) Your User Content is not pornographic, obscene,
          libelous, defamatory, tortuous, or otherwise unlawful; (f) all factual
          statements submitted by you are accurate and not misleading; and (g)
          Your User Content does not in any other way violate the Acceptable Use
          Policy (defined below).
        </p>
        <p>
          You may not state or imply that Your User Content is in any way
          provided, sponsored or endorsed by Cup O’ Sugar. Because you alone are
          responsible for Your User Content (and not Cup O’ Sugar), you may
          expose yourself to liability if, for example, Your User Content
          violates the Acceptable Use Policy. Cup O’ Sugar is not obligated to
          backup any User Content and Your User Content may be deleted at any
          time. You are solely responsible for creating backup copies of Your
          User Content if you desire. We will protect User Content in accordance
          with Cup O’ Sugar’s Privacy Policy.
        </p>
        <p>ACCEPTABLE USE POLICY</p>
        <p>The following sets forth Cup O’ Sugar’s “Acceptable Use Policy”:</p>
        <p>
          You agree not to use the Services to collect, upload, transmit,
          display, or distribute any User Content (a) that violates any
          third-party right, including any copyright, trademark, patent, trade
          secret, moral right, privacy right, right of publicity, or any other
          intellectual property or proprietary right; (b) that is unlawful,
          harassing, abusive, tortuous, threatening, harmful, abusive, invasive
          of another’s privacy, vulgar, defamatory, false, intentionally
          misleading, trade libelous, pornographic, obscene, patently offensive
          (e.g., material that promotes racism, bigotry, hatred, or physical
          harm of any kind against any group or individual) or otherwise
          objectionable material of any kind or nature or which is harmful to
          minors in any way; or (c) in violation of any law, regulation, or
          obligations or restrictions imposed by any third party.
        </p>
        <p>
          In addition, you agree not to use the Services to: (a) upload,
          transmit, or distribute any computer viruses, worms, or any software
          intended to damage or alter a computer system or data; (b) send
          unsolicited or unauthorized advertising, promotional materials, junk
          mail, spam, chain letters, pyramid schemes, or any other form of
          duplicative or unsolicited messages, whether commercial or otherwise;
          (c) harvest, collect, gather or assemble information or data regarding
          other users, including e-mail addresses, without their consent; (d)
          interfere with or disrupt servers or networks connected to the
          Services or violate the regulations, policies or procedures of such
          networks; (e) attempt to gain unauthorized access to the Services,
          other computer systems or networks connected to or used together with
          the Services, through password mining or other means; (f) attempt to
          access or search the Site, Content, or Services with any engine,
          software, tool, agent, device or mechanism other than the software
          and/or search agents provided by Cup O’ Sugar or other generally
          available third party web browsers; (f) forge any TCP/IP packet header
          or any part of the header information in any email or posting; (g)
          attempt to decipher, decompile, disassemble or reverse engineer any of
          the software used to provide the Site, Content, or Services; (h)
          access, tamper with, or use non-public areas of the Site, Apps, APIs,
          Cup O’ Sugar’s computer systems, or the technical delivery systems of
          Cup O’ Sugar’s providers; (i) attempt to probe, scan, or test the
          vulnerability of any system or network or breach any security or
          authentication measures; (j) access, tamper with, or use non-public
          areas of the Site, Cup O’ Sugar’s computer systems, or the technical
          delivery systems of Cup O’ Sugar’s providers; (k) attempt to probe,
          scan, or test the vulnerability of any system or network or breach any
          security or authentication measures; (l) in any way use the Site,
          Content or Services to send altered, deceptive or false
          source-identifying information; or (m) harass or interfere with
          another user’s use and enjoyment of the Services;
        </p>
        <p>
          We reserve the right (but have no obligation under this Agreement) to
          review any User Content, investigate, and/or take appropriate action
          against you, in our sole discretion, if you violate the Acceptable Use
          Policy or any other provision of this Agreement, including removing or
          modifying your User Content, terminating your Cup O’ Sugar Account,
          and/or reporting you to law enforcement authorities. We may also
          remove or modify your User Content if it, in our sole judgment,
          violates the rights of, harms, or threatens the safety of any other
          person, or creates liability for us or any other person. In order to
          cooperate with legitimate governmental requests, subpoenas or court
          orders, or to protect our business and customers, we may access and
          disclose any information considered necessary or appropriate,
          including your Cup O’ Sugar Account username and password, IP address
          and traffic information, usage history, and your User Content.
        </p>
        <p>APP STORES, THIRD PARTY SITES & ADS, OTHER USERS</p>
        <p>
          App Stores. You acknowledge and agree that the availability of the
          Apps is dependent on the third party from whom you received the Apps,
          e.g., the Apple iTunes App Store, Google Play, and/or other app stores
          (“App Stores”). You acknowledge that this Agreement is between you and
          Cup O’ Sugar and not with the App Stores. Cup O’ Sugar, not the App
          Stores, is solely responsible for the Apps, the content thereof,
          maintenance, support services, and warranty therefor, and addressing
          any claims relating thereto (e.g., product liability, legal
          compliance, or intellectual property infringement). You agree to pay
          all fees charged by the App Stores in connection with the Apps. You
          agree to comply with, and your license to use the Apps is conditioned
          upon your compliance with, all applicable agreements, terms of
          use/service, and other policies of the App Stores. You acknowledge
          that the App Stores (and their subsidiaries) are a third party
          beneficiary of this Agreement and will have the right to enforce this
          Agreement.
        </p>
        <p>
          Third Party Sites & Ads. The Services may contain links to third party
          sites and advertisements for third parties (collectively, “Third Party
          Sites & Ads”). Such Third Party Sites & Ads are not under the control
          of Cup O’ Sugar and Cup O’ Sugar is not responsible for any Third
          Party Sites & Ads. Cup O’ Sugar provides these Third Party Sites & Ads
          only as a convenience and does not review, approve, monitor, endorse,
          warrant, or make any representations with respect to Third Party Sites
          & Ads. Advertisements and other information provided by Third Party
          Sites & Ads may not be wholly accurate. You acknowledge sole
          responsibility for and assume all risk arising from your use of any
          such websites or resources. When you link to a Third Party Site, the
          applicable service provider’s terms and policies, including privacy
          and data gathering practices govern. You should make whatever
          investigation you feel necessary or appropriate before proceeding with
          any transaction with any third party. Your transactions and other
          dealings with Third Party Sites & Ads that are found on or through the
          Site, Apps or Services, including payment and delivery of related
          goods or services, are solely between you and such merchant or
          advertiser.
        </p>
        <p>
          Other Users. Each user of the Service is solely responsible for any
          and all their User Content. Because we do not control User Content,
          you acknowledge and agree that we are not responsible for any User
          Content and we make no guarantees regarding the accuracy, currency,
          suitability, or quality of any User Content, and we assume no
          responsibility for any User Content. Your interactions with other
          Service users are solely between you and such user. You agree that Cup
          O’ Sugar will not be responsible for any loss or damage incurred as
          the result of any such interactions. If there is a dispute between you
          and any Service user, we are under no obligation to become involved.
        </p>
        <p>
          Release. You hereby release us, our officers, employees, agents and
          successors from claims, demands any and all losses, damages, rights,
          claims, and actions of any kind including personal injuries, death,
          and property damage, that is either directly or indirectly related to
          or arises from any interactions with or conduct of any App Store, any
          other Service users, or any Third Party Sites & Ads.
        </p>
        <p>
          IF YOU ARE A CALIFORNIA RESIDENT, YOU HEREBY WAIVE CALIFORNIA CIVIL
          CODE SECTION 1542 IN CONNECTION WITH THE FOREGOING, WHICH STATES: “A
          GENERAL RELEASE DOES NOT EXTEND TO CLAIMS WHICH THE CREDITOR DOES NOT
          KNOW OR SUSPECT TO EXIST IN HIS FAVOR AT THE TIME OF EXECUTING THE
          RELEASE, WHICH, IF KNOWN BY HIM MUST HAVE MATERIALLY AFFECTED HIS
          SETTLEMENT WITH THE DEBTOR.”
        </p>
        <p>DISCLAIMERS</p>
        <p>
          THE SERVICES (INCLUDING SITE, APPS, AND CONTENT) AND USER CONTENT ARE
          PROVIDED “AS IS”, WITHOUT WARRANTY OR CONDITION OF ANY KIND, EITHER
          EXPRESS OR IMPLIED. WITHOUT LIMITING THE FOREGOING, CUP O’ SUGAR
          EXPLICITLY DISCLAIMS ANY WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
          PARTICULAR PURPOSE, TITLE, QUIET ENJOYMENT OR NON-INFRINGEMENT.
        </p>
        <p>
          CUP O’ SUGAR MAKES NO WARRANTY THAT THE SITE, APPS, CONTENT, USER
          CONTENT OR SERVICES WILL MEET YOUR REQUIREMENTS OR BE AVAILABLE ON AN
          UNINTERRUPTED, SECURE, OR ERROR-FREE BASIS. CUP O’ SUGAR MAKES NO
          WARRANTY REGARDING THE QUALITY OF ANY PRODUCTS, SERVICES, OR
          INFORMATION OBTAINED THROUGH THE SITE, APPS, CONTENT, USER CONTENT OR
          SERVICES, OR THE ACCURACY, TIMELINESS, TRUTHFULNESS, COMPLETENESS OR
          RELIABILITY OF ANY INFORMATION OBTAINED THROUGH THE SITE, APPS,
          CONTENT, USER CONTENT OR SERVICES, INCLUDING, WITHOUT LIMITATION, ANY
          INFORMATION OR ADVICE WITH RESPECT TO ANY FOOD PRODUCT. CUP O’ SUGAR
          DOES NOT REGULARLY MONITOR OR UPDATE THE ACCURACY OR RELIABILITY OF
          THE CONTENT OR USER CONTENT.
        </p>
        <p>
          NO ADVICE OR INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED FROM CUP
          O’ SUGAR OR THROUGH THE SITE, APPS, CONTENT, USER CONTENT OR SERVICES,
          WILL CREATE ANY WARRANTY NOT EXPRESSLY MADE HEREIN OR CREATE ANY
          LIABILITY ON THE PART OF CUP O’ SUGAR.
          <br />
          THE SITE, APPS, CONTENT, USER CONTENT AND SERVICES ARE FOR CONSUMER
          EDUCATIONAL USE ONLY. NOTHING CONTAINED IN THE SERVICES IS OR SHOULD
          BE CONSIDERED, OR USED AS A SUBSTITUTE FOR, MEDICAL, NUTRITIONAL OR
          ANY OTHER PROFESSIONAL ADVICE, DIAGNOSIS OR TREATMENT. THIS SITE,
          APPS, CONTENT AND THE SERVICES DO NOT CONSTITUTE THE PRACTICE OF ANY
          MEDICAL, NUTRITIONAL, DIETETIC, NURSING OR OTHER PROFESSIONAL HEALTH
          CARE ADVICE, DIAGNOSIS OR TREATMENT. CUP O’ SUGAR ADVISES USERS TO
          ALWAYS SEEK THE ADVICE OF A PHYSICIAN OR OTHER QUALIFIED, LICENSED
          HEALTH CARE PROVIDER WITH ANY QUESTIONS REGARDING PERSONAL HEALTH,
          NUTRITION OR MEDICAL CONDITIONS. NEVER DISREGARD, AVOID OR DELAY IN
          OBTAINING MEDICAL ADVICE FROM YOUR DOCTOR OR OTHER QUALIFIED, LICENSED
          HEALTH CARE PROVIDER BECAUSE OF SOMETHING YOU HAVE READ ON THE SITE OR
          APPS. CUP O’ SUGAR MAKES NO REPRESENTATIONS OR WARRANTIES ABOUT THE
          INFORMATION, TOOLS, OR CONTENT INCLUDED IN THE SITE, APPS, CONTENT,
          USER CONTENT OR SERVICES.
        </p>
        <p>
          PLEASE ALSO REVIEW THE SPECIFIC DISCLAIMERS IN SECTION “CERTAIN
          DISCLAIMERS”.
        </p>
        <p>
          SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF IMPLIED WARRANTIES,
          SO THE ABOVE EXCLUSION MAY NOT APPLY TO YOU.
        </p>
        <p>LIMITATION ON LIABILITY</p>
        <p>
          IN NO EVENT SHALL WE (AND OUR SUPPLIERS) BE LIABLE TO YOU OR ANY THIRD
          PARTY FOR ANY LOST PROFIT OR ANY INDIRECT, CONSEQUENTIAL, EXEMPLARY,
          INCIDENTAL, SPECIAL OR PUNITIVE DAMAGES ARISING FROM THIS AGREEMENT OR
          YOUR USE OF, OR INABILITY TO USE, THE SERVICES (INCLUDING THE SITE,
          APPS, OR SITE CONTENT), OR THIRD PARTY SITES & ADS, EVEN IF WE HAVE
          BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. ACCESS TO, AND USE
          OF, THE SERVICES (INCLUDING THE SITE, APPS, CONTENT AND USER CONTENT),
          AND THIRD PARTY SITES & ADS ARE AT YOUR OWN DISCRETION AND RISK, AND
          YOU WILL BE SOLELY RESPONSIBLE FOR ANY DAMAGE TO YOUR COMPUTING SYSTEM
          OR LOSS OF DATA RESULTING THEREFROM.
        </p>
        <p>
          NOTWITHSTANDING ANYTHING TO THE CONTRARY CONTAINED HEREIN, YOU AGREE
          THAT THE AGGREGATE LIABILITY OF CUP O’ SUGAR TO YOU FOR ANY AND ALL
          CLAIMS ARISING FROM THE USE OF THE SITE, CONTENT OR SERVICES IS
          LIMITED TO THE AMOUNTS YOU HAVE PAID TO CUP O’ SUGAR FOR ACCESS TO AND
          USE OF THE SITE, CONTENT, OR SERVICES. THE LIMITATIONS OF DAMAGES SET
          FORTH ABOVE ARE FUNDAMENTAL ELEMENTS OF THE BASIS OF THE AGREEMENT
          BETWEEN CUP O’ SUGAR AND YOU.
        </p>
        <p>
          SOME JURISDICTIONS DO NOT ALLOW THE LIMITATION OR EXCLUSION OF
          LIABILITY FOR INCIDENTAL OF CONSEQUENTIAL DAMAGES, SO THE ABOVE
          LIMITATION OR EXCLUSION MAY NOT APPLY TO YOU AND YOU MAY ALSO HAVE
          OTHER LEGAL RIGHTS THAT VARY FROM JURISDICTION TO JURISDICTION.
        </p>
        <p>INDEMNITY</p>
        <p>
          You agree to indemnify and hold Cup O’ Sugar, its successors,
          subsidiaries, affiliates, any related companies, its suppliers,
          licensors and partners, and the officers, directors, employees, agents
          and representatives of each of them harmless, including costs and
          attorneys’ fees, from any claim or demand made by any third party due
          to or arising out of (a) your use of the Services, (b) your User
          Content, or (c) your violation of this Agreement. Cup O’ Sugar
          reserves the right, at your expense, to assume the exclusive defense
          and control of any matter for which you are required to indemnify us
          and you agree to cooperate with our defense of these claims. You agree
          not to settle any matter without the prior written consent of Cup O’
          Sugar. Cup O’ Sugar will use reasonable efforts to notify you of any
          such claim, action or proceeding upon becoming aware of it.
        </p>
        <p>TERM AND TERMINATION</p>
        <p>
          If you violate any of these Terms of Service, your permission to use
          the Site, Apps, Content, and Services will automatically terminate.
          Cup O’ Sugar reserves the right to revoke your access to and use of
          the Site, Apps, Content, and Services at any time, with or without
          cause.
        </p>
        <p>DIGITAL MILLENNIUM COPYRIGHT ACT COMPLIANCE</p>
        <p>
          Cup O’ Sugar respects the intellectual property rights of others and
          expects users of the Site to do the same. At Cup O’ Sugar’s discretion
          and in appropriate circumstances, Cup O’ Sugar may terminate the
          accounts of users or prevent access to the Site by users who infringe
          the intellectual property rights of others. Cup O’ Sugar may access,
          preserve and disclose to third parties any of your information or data
          (including personally identifiable information and private
          communications) related to a written complaint of copyright
          infringement if Cup O’ Sugar believe in its sole discretion that such
          access, preservation, or disclosure is necessary or useful to respond
          or otherwise address such complaint. Pursuant to 17 United States Code
          512(c)(2) (Digital Millennium Copyright Act of 1998), Cup O’ Sugar’s
          designated agent for notice of alleged copyright infringement
          appearing on the Site is: Copyright Agent, <br />
          email: contact@cuposugarapp.com
          <br />
          Filing a notice of infringement with Cup O’ Sugar requires compliance
          with the requirements specified in Title II of the Digital Millennium
          Copyright Act of 1998. The text of this statute can be found at the
          U.S. Copyright Office web site, http://lcweb.loc.gov/copyright.
        </p>
        <p>GENERAL</p>
        <p>
          Changes to Terms of Service. You acknowledge and agree that Cup O’
          Sugar may revise these Terms of Service from time to time. By
          continuing to access or use the Site, Content, or Services after Cup
          O’ Sugar makes any such revision, you agree to be bound by the revised
          Terms of Service.
        </p>
        <p>
          Severability. In the event that any provision of these Terms of
          Service is held to be invalid or unenforceable, the remaining
          provisions of these Terms of Service will remain in full force and
          effect.
        </p>
        <p>
          Waiver. The failure of Cup O’ Sugar to enforce any right or provision
          of these Terms of Service will not be deemed a waiver of such right or
          provision.
          <br />
          Governing Law. This Agreement shall be governed by the laws of the
          State of Israel without giving effect to any conflict of laws
          principles that may provide the application of the law of another
          jurisdiction. Notwithstanding the foregoing, we may seek injunction or
          other equitable relief to protect our intellectual property rights in
          any court of competent jurisdiction.
        </p>
        <p>
          Copyright/Trademark Information. Copyright © 2020, Cup O’ Sugar. All
          rights reserved. All trademarks, logos and service marks (“Marks”)
          displayed on the Services are our property or the property of other
          third parties. You are not permitted to use these Marks without our
          prior written consent or the consent of such third party which may own
          the Marks.
        </p>
        <p>
          Entire Agreement. This Agreement (which includes the Privacy Policy
          and any other rules posted on the Site or Apps) constitute the entire
          and exclusive agreement between Cup O’ Sugar and you regarding the
          Site, Apps, Content, User Content, and Services, and these Terms of
          Service supersede and replace any prior agreements between Cup O’
          Sugar and you regarding the Site, Content, and Services. If any
          provision of this Agreement is, for any reason, held to be invalid or
          unenforceable, the other provisions of this Agreement will be
          unimpaired and the invalid or unenforceable provision will be deemed
          modified so that it is valid and enforceable to the maximum extent
          permitted by law. This Agreement, and your rights and obligations
          herein, may not be assigned, subcontracted, delegated, or otherwise
          transferred by you without Cup O’ Sugar’s prior written consent, and
          any attempted assignment, subcontract, delegation, or transfer in
          violation of the foregoing will be null and void. The terms of this
          Agreement shall be binding upon assignees.
        </p>
        <p>
          If you have any questions about these Terms of Service, please contact
          Cup O’ Sugar at contact@cuposugarapp.com.
        </p>
      </div>
    );
  }
}
